import React, { useEffect, useState } from "react";
import useHttp from "../../../../hooks/use-http";

import { toast } from "react-toastify";
import Pagination from "../../../../components/Pagination";
import { Modal as AntModal, Spin } from "antd";
import Modal from "react-modal";

const AqcListview = (props) => {
  const [loginUserId, setLoginUserId] = useState(localStorage.getItem("id"));
  const [canAdd, setCanAdd] = useState("none");
  const [canEdit, setCanEdit] = useState("none");
  const [canDelete, setCanDelete] = useState("none");
  const [canPdf, setCanPdf] = useState("none");
  const [canView, setCanView] = useState("none");
  const [serviceId, setServiceId] = useState("none");

  const [deleteLoading, setDeleteLoading] = useState(false);

  useEffect(() => {
    var urlpathname = window.location.pathname;
    var roleAllocation = JSON.parse(localStorage.getItem("RoleAllocation"));

    if (roleAllocation && roleAllocation.length > 0) {
      //console.log("roleAllocation", roleAllocation);

      var roleAllocationFilterList = roleAllocation.filter(
        (item) => item.serviceUrl == urlpathname
      );
      //console.log("roleAllocationFilterList", roleAllocationFilterList);
      if (roleAllocationFilterList && roleAllocationFilterList.length > 0) {
        var itemselected = roleAllocationFilterList[0];

        console.log(itemselected);

        setServiceId(itemselected.serviceId);
        if (itemselected.canAddStatus == true) {
          setCanAdd("block");
        }

        if (itemselected.canEditStatus == true) {
          setCanEdit("block");
        }

        if (itemselected.canDeleteStatus == true) {
          setCanDelete("block");
        }
        if (itemselected.canViewStatus == true) {
          setCanView("block");
        }

        if (itemselected.canPdfStatus == true) {
          setCanPdf("block");
        }
        //console.log("canAdd", canAdd);
      }
    }
  }, []);
  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
    },
    content: {
      top: "55%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      maxWidth: "80%",
      width: "700px", // Adjust the width as needed
      height: "80%",
      minHeight: "400px",
      overflow: "auto",
      border: "5px solid #96dc00",
    },
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const openModal = (data) => {
    //console.log(data);

    const id = data && data.aqcId;
    if (id) {
      getArrivalQualityCheck(
        {
          url: `/api/arrivalQualityCheck/?orgId=${localStorage.getItem(
            "orgId"
          )}&aqcId=${id}`,
        },
        (res) => {
          if (res) {
            //console.log(res);
            setSelectedData(res);
          }
        }
      );
    }

    setIsModalOpen(true);
  };
  const { addForm, update, sId } = props;
  const [data, setData] = useState([]);
  const [aqcData, setAqcData] = useState({});
  const [allData, setAllData] = useState([]);

  const aqcUrl = `/api/arrivalQualityCheck/?orgId=${localStorage.getItem(
    "orgId"
  )}`;

  const { sendRequest: getArrivalQualityCheck } = useHttp();

  const getData = () => {
    getArrivalQualityCheck(
      {
        url: aqcUrl,
      },
      (res) => {
        if (res) {
          // //console.log(res);
          const sortedData = res.output.sort((a, b) => b.aqcId - a.aqcId);
          setData(sortedData);

          setAllData(res.output);
          setAqcData(res.output[0]);
        }
      }
    );
  };

  useEffect(() => {
    getData();
  }, []);

  const handleSearch = (e) => {
      var filetrtext = e.target.value.trim().toLowerCase();

    var filterdata = allData.filter(
      (item) =>
        item.arrivalQualityCheckNo.includes(filetrtext) ||
        item.employeeName.includes(filetrtext) ||
        item.temperature.includes(filetrtext)
    );

   setData(filterdata); 
                                
setCurrentPage(1);
  };

  const { sendRequest: aqcDelete } = useHttp();

  const handleDelete = (e, aqcId) => {
    e.preventDefault();
    AntModal.confirm({
      title: "Confirm Deletion",
      content:
        "Are you sure you want to delete this Arrival Quality Check detail?",
      onOk() {
        setDeleteLoading(aqcId);
        const data = {
          aqcId: aqcId,
          serviceId: serviceId,
        };
        //console.log(data);

        aqcDelete(
          {
            url: "/api/arrivalQualityCheck/",
            method: "DELETE",
            body: data,
          },
          (data) => {
            toast.success("Data Deleted Successfully");
            getData();
            setDeleteLoading(false)
          },
          ()=>{
            setDeleteLoading(false);
          }
        );
      },
      onCancel() {  setDeleteLoading(false)},
    });
  };

  const [itemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data && data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <>
      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-6">
            <label className="card-title mx-3 my-3">
              Arrival Quality Check
            </label>
          </div>

          <div className="col-6 text-right">
            {canAdd === "block" && (
              <button
                type="button"
                className="btn  btn-primary mx-3 my-3"
                onClick={() => {
                  addForm(true);
                  sId(serviceId);
                  props.update(false);
                }}
              >
                Add Quality Check
              </button>
            )}
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body" style={{ padding: "0.4rem" }}>
                    <div className="row">
                      <div className="col-4"> </div>
                      <div className="col-4"> </div>

                      <div className="col-4">
                        <input
                          type="text"
                          name="q"
                          className="form-control"
                          onKeyUp={(e) => {
                            handleSearch(e);
                          }}
                          placeholder="Search..."
                        />
                      </div>
                    </div>
                    <br />
                    <table className="table table-bordered text-center">
                      <thead>
                        <tr>
                          <th>AQC Date</th>
                          <th>Date of Arrival</th>
                          <th>Doc No</th>
                          <th>Assigned Supervisor</th>
                          <th>Temp(°C)</th>
                          <th>Deficiences</th>

                          {canEdit === "block" && <th>Edit</th>}
                          {canDelete === "block" && <th>Delete</th>}
                          {canView === "block" && <th>View</th>}
                        </tr>
                      </thead>

                      <tbody>
                        {currentItems &&
                          currentItems.map((itm, i) => {
                            return (
                              <tr key={i}>
                                <td>{itm.aqcDate}</td>
                                <td>{itm.dateofArrival}</td>

                                <td>{itm.arrivalQualityCheckNo}</td>
                                <td>{itm.employeeName}</td>
                                <td>{itm.temperature}</td>
                                <td>{itm.deficiencies}</td>

                                {canEdit === "block" && (
                                  <td>
                                    <button
                                      onClick={() => {
                                        props.addForm(true);
                                        sId(serviceId);
                                        props.update(itm);
                                      }}
                                      className="btn"
                                    >
                                      <i className="fas fa-edit"></i>
                                    </button>
                                  </td>
                                )}
                                {canDelete === "block" && (
                                  <td>
                                   {deleteLoading=== itm.aqcId ? (
                                      <Spin />
                                    ) : (
                                      <button
                                        onClick={(e) =>
                                          handleDelete(e, itm.aqcId)
                                        }
                                        className="btn"
                                      >
                                        <i className="fa fa-trash"></i>
                                      </button>
                                    )}
                                  </td>
                                )}
                                {canView === "block" && (
                                  <td>
                                    <button
                                      className="btn"
                                      onClick={() => openModal(itm)}
                                    >
                                      <i className="fas fa-eye"></i>
                                    </button>
                                  </td>
                                )}
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
      {/* view modal */}
      <Modal isOpen={isModalOpen} style={customModalStyles}>
        {selectedData && (
          <div>
            <h4 className="card-title">Arrival Quality Check Details</h4>
            <div className="card-tools text-right">
              <button
                type="button"
                className="btn btn-tool"
                data-card-widget="remove"
                onClick={() => setIsModalOpen(false)}
              >
                <i className="fas fa-times" />
              </button>
              <hr />
            </div>
            <div className="row">
              <p className="col-md-6" style={{ textAlign: "left" }}>
                Arrival Quality Check No: {selectedData.arrivalQualityCheckNo}
              </p>
              <p className="col-md-6" style={{ textAlign: "left" }}>
                Arrival Quality Check Date: {selectedData.aqcDate}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">
                Assign Supervisor: {selectedData.employeeName}
              </p>
              <p className="col-md-6">
                Procurement Reciept No : {selectedData.email}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">
                Temperature (°C) : {selectedData.temperature}
              </p>

              <p className="col-md-6">
                Deficiencies: {selectedData.deficiencies}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">
                Harvest Date : {selectedData.harvestDate}
              </p>

              <p className="col-md-6">
                Shelf Life Days : {selectedData.shelfLifeDays}
              </p>
            </div>
            <div className="row">
              <p className="col-md-6">
                Average Unit Weight: {selectedData.avgUnitWeight}
              </p>
              <p className="col-md-6">Unit: {selectedData.unit}</p>
            </div>
            <br />
            <h5 className="card-title">Product Details</h5>
            <table className="table table-bordered table-sm">
              <thead>
                <tr className="">
                  <th>Sr. No</th>
                  <th>Item Id</th>

                  <th>Item Type</th>
                  <th>Item Category</th>
                  <th>Item Description</th>
                  <th>Item Quantity</th>
                  <th>Unit</th>
                </tr>
              </thead>
              <tbody>
                {selectedData.productDetails &&
                  selectedData.productDetails.map((itm, i) => {
                    return (
                      <tr key={i}>
                        <td>{i + 1}</td>
                        <td>{itm.itemId}</td>
                        <td>{itm.cropName}</td>
                        <td>{itm.varietyName}</td>
                        <td>{itm.productName}</td>
                        <td>{itm.itemQuantity}</td>
                        <td>{itm.unitAbbreviation}</td>
                      </tr>
                    );
                  })}
              </tbody>
            </table>
            <h5 className="card-title">Freshness Details</h5>
            <table className="table tabel-sm text-center table-bordered">
              <thead>
                <tr>
                  <th>Average Unit Size</th>
                  <th>Unit</th>
                  <th>Shape</th>
                  <th>Colour</th>
                  <th>Flesh Firmness</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{selectedData.bankAcNo}</td>
                  <td>{selectedData.AccountHolderName}</td>
                  <td>{selectedData.IFSC}</td>
                </tr>
              </tbody>
            </table>{" "}
            {/**/}
          </div>
        )}
      </Modal>
    </>
  );
};

export default AqcListview;
